module.exports = "/app/user/img/STANDARD.87604912.png";